import { Box, Paper, Typography } from '@mui/material';
import { ItemWithId } from 'services/constants/types';
import { PaginationBlock } from 'ui/PaginationBlock';
import { PAGE_SIZE } from 'services/constants/env';
import { TEasTableWithoutFilterProps } from './types';
import { EasTable } from '../EasTable';
import { COLORS } from 'services/constants/colors';

export const EasTableWithoutFilter = <T extends ItemWithId>({
	tableStructure,
	items,
	itemsIsLoading,
	handleAction,
	handleLink,
	skeletonRows,
	highlightedRow,
	children,
	showButtons,
	minWidth = 1000,
	paginationBlock = true,
	pageSize = PAGE_SIZE,
}: TEasTableWithoutFilterProps<T>) => {
	return (
		<Box>
			<Paper
				sx={{
					margin: '0px 10px 0 10px',
					maxWidth: 'calc(100vw - 20px)',
					overflowX: 'auto',
				}}
			>
				<Box sx={{ width: 'auto', minWidth }}>
					<Box sx={{ borderRadius: '12px' }}>
						{children && (
							<Box
								sx={{
									backgroundColor: COLORS.BACKGROUND_SECONDARY,
									p: 0.5,
								}}
							>
								{children}
							</Box>
						)}
						<EasTable<T>
							tableStructure={tableStructure}
							items={items?.data ?? null}
							itemsIsLoading={itemsIsLoading}
							handleAction={handleAction}
							handleLink={handleLink}
							skeletonRows={skeletonRows}
							highlightedRow={highlightedRow}
							showButtons={showButtons}
						/>
					</Box>
				</Box>
			</Paper>
			<Box
				sx={{
					padding: '0 20px 20px 20px',
					display: 'flex',
					justifyContent: 'space-between',
				}}
			>
				{paginationBlock ? (
					<PaginationBlock
						total={items?.totalCount ?? 0}
						isLoading={itemsIsLoading}
						pageSize={pageSize}
					/>
				) : (
					<div />
				)}
				{!!items?.totalCount && (
					<Box
						sx={{
							pt: '20px',
							display: 'flex',
							flexDirection: 'row',
						}}
					>
						<Typography
							sx={{
								fontSize: '1rem',
								color: '#555',
							}}
						>
							{items?.totalCount ? `Total items: ` : ''}
						</Typography>
						&nbsp;
						<Typography
							sx={{
								fontSize: '1rem',
								fontWeight: 'bold',
								color: 'primary.main',
							}}
						>
							{items?.totalCount ? `${String(items?.totalCount ?? '')} ` : 'No data found'}
						</Typography>
					</Box>
				)}
			</Box>
		</Box>
	);
};
